 
<div id="scanner-content" class="scanner-page">

  <dx-load-panel #loadPanel container="#scanner-content" [showIndicator]="true" shadingColor="rgba(0,0,0,0.2)"
  [showPane]="false" [shading]="true" [visible]="isLoading" [position]="{ of: '#scanner-content' }"></dx-load-panel>
  
  


  
  <div class="scanner-preview">
    <!-- <div class="scanner-operations"> -->
      <!-- <dx-button hint="90° döndür" icon="refresh" (onClick)="rotate(rotateVal+90)"> </dx-button>
       <dx-button hint="Threshold arttır" icon="sun" (onClick)="changeImageContrast(true)"> </dx-button>
      <dx-button hint="Threshold azalt" icon="sun" (onClick)="changeImageContrast(false)"> </dx-button> -->
      <!-- <dx-button hint="Parlaklık arttır" icon="moon" (onClick)="changeImageBrightness(true)"> </dx-button>
      <dx-button hint="Parlaklık azalt" icon="moon" (onClick)="changeImageBrightness(false)"> </dx-button>
      <dx-button hint="Kes" icon="cut" (onClick)="cropImage()"> </dx-button>
      <dx-button hint="Zoom IN" icon="plus" (onClick)="zoom(true)"> </dx-button>
      <dx-button hint="Zoom OUT" icon="minus" (onClick)="zoom(false)"> </dx-button> -->

    <!-- </div> -->

  
    <div *ngIf="scanningState === 2" class="alert alert-danger text-center">
      <strong>Error:</strong> {{ error }}
    </div>
  
    <div *ngIf="scanningState === 0 && scannedImages.length > 0" class="alert alert-secondary">
      <!-- <div class="row">
        <div class="col-md-4">
          <button class="btn btn-info" (click)="prevImage()">
            <i class="fa fa-chevron-left"></i>
          </button>
        </div>
        <div class="col-md-4 text-center">
          <h4>Scan result: {{ curImgIndex + 1 }} of {{ scannedImages.length }}</h4>
        </div>
        <div class="col-md-4 text-right">
          <button class="btn btn-info" (click)="nextImage()">
            <i class="fa fa-chevron-right"></i>
          </button>
        </div>
      </div> -->
      <div class="text-center">
        <img
          [src]="scannedImages[curImgIndex]"
          id="scanningImageResult"
          [width]="350"
          [height]="400"
        />
      </div>

      <div class="page-buttons" *ngIf="scanningState === 0 && scannedImages.length > 0">


        <dx-button class="page-button" icon="back" (onClick)="prevImage()"> </dx-button>
       <div id="imagesInfo" class="imagesInfo">{{ curImgIndex + 1 }}/{{scannedImages.length}}</div>
       <dx-button class="page-button" icon="chevronnext" (onClick)="nextImage()"> </dx-button>
    
    
     </div>
    </div>


    <!-- <input   type="image" class="scanned-img" id="previewImage" alt="" [width]="imgWidth" [height]="imgHeight" />


       <iframe
      [width]="imgWidth" [height]="imgHeight"
      type="application/pdf"
        *ngIf="showPdfYn && fileUrl"
        [src]="fileUrl"
        (load)="onDocumentLoad()"
        (error)="onFileError()"
      ></iframe> -->





 

  </div>


  <div class="scanner-options">
    <h4 class="scanner-label">JS Print Manager</h4>
    <dx-select-box
    [label]="'Cihaz:'"
    [labelMode]="'outside'"
    [dataSource]="scannerDevices"
    placeholder="Cihaz Seçiniz"
    (selectedItemChange)="getSelectedDevice($event)"
    [displayExpr]="'name'"
    valueExpr="name"
    [value]="scannerName"

  >
  </dx-select-box>


  <dx-select-box
  [dataSource]="documentPixelTypes"
  placeholder="Renk Tipi Seçiniz"
  [label]="'Renk Tipi:'"
  [labelMode]="'outside'"
  (selectedItemChange)="getSelectedPixelType($event)"
  [displayExpr]="'name'"
  [valueExpr]="'value'"
  [value]="selectedDocumentPixelType"
>
</dx-select-box>


<dx-select-box
[dataSource]="documentResolutionTypes"
placeholder="Çözünürlük Seçiniz"
[label]="'Çözünürlük:'"
  [labelMode]="'outside'"
(selectedItemChange)="getSelectedResolutionType($event)"
[displayExpr]="'name'"
[valueExpr]="'value'"

[value]="selectedDocumentResolution"
>
</dx-select-box>



<dx-select-box
[dataSource]="documentExportType"
placeholder="Belge Tipi Seçiniz"
[label]="'Belge Tipi:'"
[labelMode]="'outside'"
(selectedItemChange)="getSelectedDocType($event)"
[displayExpr]="'name'"
[valueExpr]="'name'"
[value]="selectedDocumentExportType"
>
</dx-select-box>

 
            <dx-number-box
            [label]="'Feeder Count:'"
            placeholder="Feeder Count"
            [value]="feederCount"
            (valueChange)="feederCount = $event"
            [min]="0"
            [max]="100"
            ></dx-number-box>

<div class="scanner-check-options">
  <dx-check-box 
  text="ADF Kullan"
  [(value)]="enableFeeder"
  (onValueChanged)="enableFeeder=$event.value">


</dx-check-box>

<dx-check-box 
text="Duplex Tara"
[(value)]="enableDuplex"
(onValueChanged)="enableDuplex=$event.value">
</dx-check-box>


<dx-check-box 
text="UI göster"
[(value)]="showUI"
(onValueChanged)="showUI=$event.value">
</dx-check-box>


<dx-check-box 
text="işlemi göster"
[(value)]="showProgressUI"
(onValueChanged)="showProgressUI=$event.value">
</dx-check-box>
</div>

 



    <dx-button
             [text]="'Tarama Yap'"
            type="default"
            stylingMode="contained"
            (click)="doScanning()"
          ></dx-button>


          <dx-button
          [disabled]="!canSaveFile"
          [text]="'Kaydet'"
          type="default"
          stylingMode="contained"
          (click)="exportFileAsBase64Content()"
            ></dx-button>

  </div>


</div>
<a style="float:right;margin-right:250px" href="https://www.neodynamic.com/downloads/jspm/jspm7-7.0.24.1015-win32.exe">Uygulamayı buradan indirebilirsiniz</a><br /> 
